import { reactive as reactiveVue } from 'vue';
/**
 * Re-export of vue reactive funtion with option to define the output type.
 */
export const reactive = reactiveVue;
//# sourceMappingURL=reactive.js.map